import UIComponent from "../ui/component";

export class ExportModal extends UIComponent {
    init() {
        this.currentTranscriptionId = null;
        this.states = {
            speakers: false,
            timestamps: false,
            subtitles: false,
            maxLines: 2,
            maxSymbols: 35
        };


        this.updateStatesFromCheckboxes();
        this.setupEventListeners();
      
    
    }

    setupEventListeners() {
        this.speakersCheckbox?.on("change", () => {
            this.states.speakers = this.speakersCheckbox.isChecked();
            this.updateHrefs();
        });

        this.timestampsCheckbox?.on("change", () => {
            this.states.timestamps = this.timestampsCheckbox.isChecked()
            this.updateHrefs();
        });

        this.subtitlesCheckbox?.on("change", () => {
            this.states.subtitles = this.subtitlesCheckbox.isChecked();
            this.toggleSpeakerSelectVisibility();
            this.updateHrefs();
        });

        this.selectSpeaker.selectStroke?.on('change', () => {
            this.states.maxLines = parseInt(this.selectSpeaker.selectStroke.element.value);
            this.updateHrefs();
        });

        this.selectSpeaker.selectSymbol?.on('change', () => {
            this.states.maxSymbols = parseInt(this.selectSpeaker.selectSymbol.element.value);
            this.updateHrefs();
        });
    }

    updateStatesFromCheckboxes() {
        this.states.speakers = this.speakersCheckbox?.isChecked() || false;
        this.states.timestamps = this.timestampsCheckbox?.isChecked() || false;
        this.states.subtitles = this.subtitlesCheckbox?.isChecked() || false;
        
        if (this.selectStroke) {
            this.states.maxLines = parseInt(this.selectSpeaker.selectStroke.element?.value) ;
            
        }
        if (this.selectSymbol) {
            this.states.maxSymbols = parseInt(this.selectSpeaker.selectSymbol.element?.value) ;
               
        }
    }

    updateHrefs() {
        const exportTypes = ['text', 'word', 'excel', 'subtitles'];
        
        exportTypes.forEach(type => {
            const link = this[`${type}ExportLink`];

     
            if (!link) {
                console.warn(`Export link for ${type} not found`);
                return;
            }

            try {
                const url = new URL(link.element.href);
          
                url.searchParams.set('type', type);
                url.searchParams.set("speakers", this.states.speakers ? "1" : "0");
                url.searchParams.set("timestamps", this.states.timestamps ? "1" : "0");

                if (this.states.subtitles) {
                    url.searchParams.set("maxLineCount", this.states.maxLines.toString());
                    url.searchParams.set("maxLineWidth", this.states.maxSymbols.toString());
                    console.log(this.states.maxLines.toString())
                } else {
                    url.searchParams.delete("maxLineCount");
                    url.searchParams.delete("maxLineWidth");
                }

                link.element.href = url.toString();
            } catch (error) {
                console.error(`Failed to update ${type} export link:`, error);
            }
        });
    }

    toggleSpeakerSelectVisibility() {
        if (this.states.subtitles) {
            this.selectSpeaker?.show();
        } else {
            this.selectSpeaker?.hide();
        }
    }
}